// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"install-mobile"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M14 2H5V22H19V12M12 18H12.0039V18.0039H12V18Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M16.498 5.49942L19.0006 8.00196L21.5012 5.50127M19.0006 7.25V2.00195","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-install-mobile')
export default class InstallMobileIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'install-mobile',
    }
  }
}
